interface HeroAceleraProps {
  onOpenModal: () => void;
}

export default function HeroAcelera({ onOpenModal }: HeroAceleraProps) {
  return (
    <section className="relative min-h-[600px] sm:min-h-[700px] lg:min-h-screen flex items-center justify-center overflow-hidden bg-slate-950">
      {/* Subtle orange overlay */}
      <div className="absolute inset-0 bg-orange-500/5" />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900/50 to-slate-950" />
      
      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white space-y-8 sm:space-y-12 py-12 sm:py-16 lg:py-24 px-4">
          {/* Headline */}
          <div className="space-y-4 sm:space-y-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold leading-tight tracking-tight">
              Você não está vendendo pouco.
              <span className="block text-orange-600 mt-4">
                Você está vendendo sem estrutura.
              </span>
            </h1>
            
            <div className="text-base sm:text-lg lg:text-xl text-gray-400 leading-relaxed sm:leading-loose max-w-3xl mx-auto space-y-4 sm:space-y-6 mt-6 sm:mt-12">
              <p>
                Empresas que crescem todos os meses não dependem de sorte, indicação ou impulso.
              </p>
              <p className="text-white font-medium">
                Elas têm um sistema previsível de geração e fechamento de vendas.
              </p>
              <p className="text-orange-600 font-semibold text-lg sm:text-xl mt-4 sm:mt-8">
                Nós estruturamos esse sistema para você.
              </p>
            </div>
          </div>
          
          {/* Benefits - Minimalist */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 max-w-3xl mx-auto mt-8 sm:mt-16">
            <div className="flex items-start gap-3 sm:gap-4 text-left bg-white/5 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-white/10">
              <div className="w-1 h-12 bg-orange-600 rounded-full flex-shrink-0"></div>
              <span className="text-sm sm:text-base text-gray-300 leading-relaxed">Captação constante de novos clientes</span>
            </div>
            
            <div className="flex items-start gap-3 sm:gap-4 text-left bg-white/5 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-white/10">
              <div className="w-1 h-12 bg-orange-600 rounded-full flex-shrink-0"></div>
              <span className="text-sm sm:text-base text-gray-300 leading-relaxed">CRM organizado que não deixa oportunidades escaparem</span>
            </div>
            
            <div className="flex items-start gap-3 sm:gap-4 text-left bg-white/5 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-white/10">
              <div className="w-1 h-12 bg-orange-600 rounded-full flex-shrink-0"></div>
              <span className="text-sm sm:text-base text-gray-300 leading-relaxed">Automação inteligente que faz o follow-up por você</span>
            </div>
            
            <div className="flex items-start gap-3 sm:gap-4 text-left bg-white/5 backdrop-blur-sm rounded-lg p-4 sm:p-6 border border-white/10">
              <div className="w-1 h-12 bg-orange-600 rounded-full flex-shrink-0"></div>
              <span className="text-sm sm:text-base text-gray-300 leading-relaxed">Recuperação estratégica de clientes inativos</span>
            </div>
          </div>
          
          {/* CTA - Clean */}
          <div className="flex justify-center mt-8 sm:mt-16">
            <button 
              onClick={onOpenModal}
              className="bg-green-600 hover:bg-green-700 text-white px-8 sm:px-12 py-3 sm:py-4 rounded-lg font-bold text-sm sm:text-base transition-all duration-300 cursor-pointer w-full sm:w-auto max-w-md"
            >
              <i className="ri-calendar-line mr-2"></i>
              AGENDAR REUNIÃO
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
